import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=7fa98172&scoped=true"
import script from "./TopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=7fa98172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa98172",
  null
  
)

export default component.exports